<template>
  <div>
    <vs-popup
      :title="$t('AgentProductsSegment') + agentName"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row">
          <div class="vx-col sm:w-5/6 w-full mb-2">
            <label class="vs-select--label">{{ $t("Contract") }}</label>
            <v-select
              label="title"
              name="contract"
              :options="allContracts"
              :reduce="(x) => x.id"
              v-model="agentSegmentInfo.contractId"
              ref="contractSelectList"
              dir="rtl"
              :key="inputsKey"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('contract')">{{
              errors.first("contract")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-5/6 w-full">
            <label class="vs-select--label">{{ $t("ProductSegment") }}</label>
            <v-select
              label="name"
              name="agent"
              v-model="agentSegmentInfo.segmentId"
              :options="segments"
              :reduce="(x) => x.id"
              ref="productSegment"
              v-validate="'required'"
              dir="rtl"
              :key="inputsKey"
            ></v-select>
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn"
              @click.prevent="assignSegment()"
            ></vs-button>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('ProductSegment') },
          { title: $t('Contract') },
          { title: $t('Action') },
        ]"
        class="pb-6"
      >
        <template slot-scope="{ row }">
          <td style="width: 40%">
            {{ row.name }}
          </td>
          <td style="width: 40%">
            {{ row.contractTitle }}
          </td>
          <td style="width: 17%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignSegment(row)"
              class="d-inline"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}

.vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    product: {
      required: "لطفا محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_SalesPersons_AgentSegmentPopup",
  props: {
    show: { default: false },
    agentSegmentModel: {
      default: {},
    },
    keywords: {},
  },

  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},
      agentSegmentInfo: {},
      unassignModel: {},
      agentName: "",
      searchQueryNew: "",
      searchQueryOld: "",
      inputsKey: 0,
      segments: [],
      segmentsLoading: true,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
        // this.agentSegmentInfo.contractId = "";
        // this.agentSegmentInfo.segmentId = "";
      },
    },
    ...mapGetters({
      allContracts: "sale/listContract",
    }),
  },
  mounted() {
    this.fetchContract();
    this.getSegments().then((response) => {
      this.segmentsLoading = false;
      if (!response.success) {
        this.segments = response;
      }
    });
  },
  methods: {
    ...mapActions({
      fetchContract: "sale/fetchContractList",
      assignAgentSegment: "productSegment/assignAgentSegment",
      unassignAgentSegment: "productSegment/unassignAgentSegment",
      getSegments: "productSegment/getAllSegments",
    }),
    assignSegment() {
      this.agentSegmentInfo.agentId = this.agentSegmentModel.agentId;
      this.agentSegmentInfo.salePersonId = this.agentSegmentModel.salePersonId;
      this.assignAgentSegment(this.agentSegmentInfo).then(() => {
        this.agentSegmentInfo = {};
        this.$vs.notify({
          title: "عملیات موفق",
          text: "رکورد مورد نظر با موفقیت اضافه شد!",
          color: "success",
        });
        this.$refs.grid.renderGrid();
      });
      this.inputsKey++;
    },
    unassignSegment(model) {
      this.unassignModel = {};
      this.unassignModel = {
        agentId: this.agentSegmentModel.agentId,
        segmentId: model.segmentId,
        contractId: model.contractId,
        salePersonId: this.agentSegmentModel.salePersonId,
      };
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignAgentSegment(this.unassignModel).then(() => {
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 300);
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.agentSegmentInfo = {};
        if (this.agentSegmentModel.agentName != null) {
          this.agentName = ": " + this.agentSegmentModel.agentName;
        } else {
          this.agentName = "-";
        }
        this.$validator.reset();
        this.gridDataSource = {
          type: "app",
          service:
            "Sales/api/SaleAgentsQuery/" +
            this.agentSegmentModel.agentId +
            "/" +
            this.agentSegmentModel.salePersonId +
            "/SegmentInfos",
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = {};
      }
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
  },
};
</script>
